import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  ISelectStudioFormModel,
  selectStudioFormDefaultValues,
  selectStudioFormSchema,
} from "../models/selectStudioFormModel";
import { IStudioSelectItemModel } from "../../../infrastructure/models/studioSelectItemModel";
import { useEffect } from "react";

export const useSelectStudioForm = (userStudios: IStudioSelectItemModel[]) => {
  const form = useForm<ISelectStudioFormModel>({
    defaultValues: selectStudioFormDefaultValues,
    resolver: yupResolver(selectStudioFormSchema),
  });

  useEffect(() => {
    if (userStudios.length > 0) {
      form.setValue("selectedStudioId", userStudios[0].id);
    }
  }, [userStudios]);

  return form;
};
